module.exports = __webpack_public_path__ + "media/Ring 4.732cce23.mp3";